import React from 'react';
import './AboutSection.css';

const aboutBadges = [
  { icon: '🌟', label: '98% Client Satisfaction' },
  { icon: '🚀', label: '20+ Successful Projects' },
  { icon: '🧠', label: '1.5+ Years of Experience' },
];

const About: React.FC = () => (
  <section className="about-cn-section" style={{minHeight: '78vh'}}>
    <h2 className="about-cn-title gradient-text">About CodeNova AI</h2>
    <div className="about-cn-desc">
      At CodeNova AI, we’re passionate about bridging ideas and innovation. We help brands level up with smart AI, stunning web experiences, and seamless automation.
      <br />From concept to launch, we bring expertise, creativity, and a relentless drive for results — empowering your business every step of the way.
    </div>
    <div className="about-cn-badges-row">
      {aboutBadges.map((badge, idx) => (
        <div className="about-cn-badge" key={idx}>
          <span className="badge-icon">{badge.icon}</span>
          <span className="badge-label">{badge.label}</span>
        </div>
      ))}
    </div>
  </section>
);
export default About;
